import { render, staticRenderFns } from "./IconSvgBubble.vue?vue&type=template&id=54c25b8e&scoped=true&"
import script from "./IconSvgBubble.vue?vue&type=script&lang=js&"
export * from "./IconSvgBubble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c25b8e",
  null
  
)

export default component.exports